import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import * as loginSelectors from '../../../../root-store/login-store/login.selector';
import * as selectors from '../../../../root-store/relationship-store/relationship.selector';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ShareService } from '@app/shared/services/vault/share.service';
import * as selectorsRelationship from '../../../../root-store/relationship-store/relationship.selector';
import { ConfigurationType } from '@app/shared/component/manage-element/manage-combo-element/enum';
import { AccessibilitySettingsComponent } from '@app/shared/component/accessibility-settings/accessibility-settings.component';
import { databaseToBootstrap, stringDateToDatabase } from '@app/shared/utils';
import { FolderEncryptedSuccessComponent } from '@app/modules/vault/components/dialogs/folder-encrypted-success/folder-encrypted-success.component';
import { ToastrService } from 'ngx-toastr';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import moment from 'moment';
import { RootStoreState } from '@app/root-store';
//
import { EVENTS } from '@app/constants/events.constants';
import { AuthService, UserService } from '@app/shared/services';
import { fetchUserAttributes } from '@aws-amplify/auth';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'vault-setup-sharing',
  templateUrl: './vault-setup-sharing.component.html',
  styleUrl: './vault-setup-sharing.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VaultSetupSharingComponent implements OnInit, OnDestroy {
  @Input() personalVaultName;
  @Input() selectedStepInfo: any = {};
  @Input() stepInfo: any = {};
  @Input() stateObject: any = {};
  @Input() selectedIndex;
  @Input() selectedVaultType;
  @Input() userObject;
  @Input() isFromVault = false;
  @Input() vaultSharing = [];
  @Output() setVaultSharing = new EventEmitter();
  screenWidth: number;
  resizeObservable$: Observable<Event>;
  subscription: Subscription = new Subscription();

  options = [
    {
      value: 'Yes',
      isSelected: false,
    },
    {
      value: 'No',
      isSelected: false,
    },
  ];

  allUserConnections = [];
  selectedMember;
  nonProfessionalUsers = [];
  connectionUserFormControl = new UntypedFormControl();
  selectedUser;
  newShareTypeDetails;
  isVaultSetupLoading = false;
  switchFromUser: boolean = false;

  constructor(
    private cd: ChangeDetectorRef,
    private store: Store,
    private vaultShareService: ShareService,
    private injector: Injector,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private _userService: UserService,
    private store$: Store<RootStoreState.State>,
    private authService: AuthService
  ) {
    this.subscription.add(
      this.store.select(loginSelectors.getCurrentUserDetails).subscribe((data) => {
        this.selectedMember = data;
      })
    );
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );
    this.subscription.add(
      this.store$.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe(async (result) => {
        try {
          if (result) {
            this.personalVaultName = result.nick_name;
            this.switchFromUser = true;
          }
          const authUser = this.authService.user;
          if (result?.switch_from_user_id && result?.id != authUser['id']) {
            this.switchFromUser = true;
          } else {
            this.switchFromUser = false;
          }
        } catch (ex) {}
      })
    );
    this.getMemberData();
    this.isVaultSetupLoading = true;
    if (!this.isFromVault) {
      this.getVaultSharingData();
    } else {
      this.nonProfessionalUsers = this.vaultSharing;
      this.isVaultSetupLoading = false;
    }
  }

  getVaultSharingData(isFromDelete = false) {
    this.subscription.add(
      this.vaultShareService.getVaultShareInformation(this.userObject.id, this.stateObject?.id ? this.stateObject?.id : null).subscribe((data) => {
        this.nonProfessionalUsers = [...data];
        if (!isFromDelete) {
          if (this.nonProfessionalUsers.length > 0) {
            this.selectedStepInfo.isAnswerSelected = true;
            this.stepInfo[this.selectedVaultType][this.selectedIndex].answer = 'Yes';
            this.stepInfo[this.selectedVaultType][this.selectedIndex].isAnswerSelected = true;
          } else {
            if (this.stepInfo[this.selectedVaultType][this.selectedIndex].answer) {
              this.options.forEach((opt) => {
                opt.isSelected = opt.value === this.stepInfo[this.selectedVaultType][this.selectedIndex].answer;
              });
            }
            this.stepInfo[this.selectedVaultType][this.selectedIndex].isAnswerSelected = false;
          }
        }

        this.isVaultSetupLoading = false;
        this.cd.detectChanges();
      })
    );
  }

  getMemberData() {
    this.subscription.add(
      this.store.select(selectorsRelationship.getAndFilterNonProfessionalExcludeExistingUser('', [])).subscribe((data) => {
        let updatedObject = [];
        data.forEach((element, index) => {
          let tempEllemt = {
            ...element,
            name: '',
          };
          tempEllemt.id = element?.user_id;
          tempEllemt.name = element?.user_first_name + ' ' + element?.user_last_name;
          updatedObject.push(tempEllemt);
        });
        this.allUserConnections = [
          ...updatedObject.map(({ id, user_id, name, relationship_name, user_profile_image_url }) => ({
            id,
            user_id,
            name,
            relationship_name,
            user_profile_image_url,
            key: ConfigurationType.USERS,
          })),
        ];
        this.allUserConnections = this.allUserConnections.filter((d) => d.id !== this.selectedMember.id);
      })
    );
  }

  selectConnectedUser(user, isInvite) {
    this.connectionUserFormControl.disable();
    const memberUser = {
      id: user.id ? user.id : user.user_id,
      user_id: user.id ? user.id : user.user_id,
      from_user_id: user.from_user_id,
      connection_status: user.connection_status,
      relationship_name: user.relationship_name,
      memberUser: user,
    };
    this.selectedUser = memberUser;
    this.launchNewShareOptionsDialog(memberUser);

    // this.nonProfessionalUsers = [...this.nonProfessionalUsers, memberUser];
  }

  launchNewShareOptionsDialog(memberUser) {
    const accessibilityDialog = this.dialog.open(AccessibilitySettingsComponent, {
      data: {
        sharedObjectType: 'file',
        shareDetails: null,
        profile_image: memberUser?.memberUser?.user_profile_image_url,
        name: memberUser?.memberUser?.name,
        relationship_name: memberUser?.memberUser?.relationship_name,
        fromAutoComplete: true,
      },
      // width: '250px',
      // height: '380px',
      panelClass: 'full-window-dialog-2',
      autoFocus: false,
    });

    this.subscription.add(
      accessibilityDialog.afterClosed().subscribe((results) => {
        if (results) {
          this.newShareTypeDetails = results;
          if (this.isFromVault) {
            const selectedUser = {
              name: memberUser?.memberUser?.name,
              user_profile_image_url: memberUser?.memberUser?.user_profile_image_url,
              user_id: memberUser.user_id,
              vault_user_share_end_date: null,
              vault_user_share_is_editable: this.newShareTypeDetails.is_editable ? 1 : 0,
              vault_user_share_is_sealed: this.newShareTypeDetails.is_sealed ? 1 : 0,
              vault_user_share_share_date: moment(this.newShareTypeDetails.share_date).format('YYYY-MM-DD'),
              newShareTypeDetails: this.newShareTypeDetails,
              ...memberUser,
            };
            this.nonProfessionalUsers = [...this.nonProfessionalUsers, selectedUser];
            this.setVaultSharing.emit(this.nonProfessionalUsers);
            this.cd.detectChanges();
          } else {
            this.createShared();
          }
        }
      })
    );
  }

  createShared() {
    if (!this.newShareTypeDetails) {
      //if no options have been selected set defaults
      this.newShareTypeDetails = { share_date: new Date(Date.now()).toLocaleDateString(), is_sealed: false };
    }

    let obj = {
      connection_status: this.selectedUser.connection_status,
      is_sealed: this.newShareTypeDetails.is_sealed,
      is_editable: this.newShareTypeDetails.is_editable,
      share_date: this.newShareTypeDetails.share_date ? stringDateToDatabase(this.newShareTypeDetails.share_date) : null,
      end_date: this.newShareTypeDetails.end_date ? stringDateToDatabase(this.newShareTypeDetails.end_date) : null,
      shared_with_user_id: this.selectedUser.id,
      user_id: this.userObject.id,
      vault_id: this.stateObject?.id ? this.stateObject?.id : null,
    };
    if (obj['vault_id'] == null) {
      delete obj['vault_id'];
    }
    this.subscription.add(
      this.vaultShareService.createVaultShareInformation(obj).subscribe(async (results) => {
        if (results?.securityKey) {
          this.dialog.open(FolderEncryptedSuccessComponent, {});
        }
        this.toastr.success(`${this.personalVaultName} Folder shared with ${this.selectedUser.memberUser.name}`);
        await this.getVaultSharingData();
        //this.getAllConnections();
        this.trackEventsInMixPanel('add');
        //refresh modal
        this.cd.detectChanges();
      })
    );
  }

  // deleteSharing(user, isNonProfessionalRelationship?: boolean) {
  //   if (isNonProfessionalRelationship) {
  //     this.nonProfessionalUsers = this.nonProfessionalUsers.filter((item) => item.id != user.id);
  //   }
  // }

  deleteSharing(existingUser) {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete',
        materialIcon: 'delete',
        text: `Are you sure you want to delete this user's access to this information?`,
        proceedTitle: 'Delete',
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          if (this.isFromVault) {
            this.nonProfessionalUsers = this.nonProfessionalUsers.filter((item) => item.id != existingUser.id);
            this.setVaultSharing.emit(this.nonProfessionalUsers);
            this.cd.detectChanges();
          } else {
            this.subscription.add(
              this.vaultShareService
                .deleteVaultShareInformation({
                  user_id: this.userObject.id,
                  id: existingUser.vault_user_share_id,
                })
                .subscribe((results) => {
                  this.getVaultSharingData(true);
                  // this.getAllConnections();
                  this.trackEventsInMixPanel('remove');
                  //refresh modal
                  this.cd.markForCheck();
                })
            );
          }
        }
      })
    );
  }

  handleSubFlow(response: string, flow: any) {
    this.options.forEach((opt) => {
      opt.isSelected = opt.value === response;
    });
    this.stepInfo[this.selectedVaultType][this.selectedIndex].answer = response;
    this.cd.detectChanges();
  }

  setShareDetails(existingUser) {
    return {
      ...existingUser,
      end_date: existingUser.vault_user_share_end_date,
      share_date: existingUser.vault_user_share_share_date,
      is_sealed: existingUser.vault_user_share_is_sealed,
      is_editable: existingUser.vault_user_share_is_editable,
    };
  }

  buildShareTypeText(shareDetails) {
    let shareTypeText = 'Accessible Now';
    if (!shareDetails.share_date) {
      shareTypeText = 'Accessible on a later date';
    } else if (new Date(shareDetails.share_date) < new Date(Date.now())) {
      shareTypeText = 'Accessible Now';
    } else {
      const displayDate = databaseToBootstrap(new Date(shareDetails.share_date).toUTCString());
      const selectedDate = new Date(shareDetails.share_date);

      const momentDate = moment(selectedDate);

      // this.shareTypeText = `Accessible on ${displayDate.month.slice(0, 3)} ${displayDate.day} ${displayDate.year}`;

      shareTypeText = `Accessible on ${moment(momentDate).format('MMM DD YYYY')}`;
    }
    let isSealed = shareDetails.is_sealed;
  }

  shareTypeSelectionClicked(user) {
    const data = this.setShareDetails(user);
    const shareDetails = {
      end_date: data.end_date,
      share_date: data.share_date,
      is_sealed: data.is_sealed,
      is_editable: data.is_editable,
    };
    const shareTypeDialog = this.dialog.open(AccessibilitySettingsComponent, {
      data: {
        sharedObjectType: 'information',
        shareDetails: shareDetails,
        profile_image: user.user_profile_image_url,
        name: user.user_first_name + ' ' + user.user_last_name,
      },
      // width: '250px',
      // height: '410px',
      panelClass: 'full-window-dialog-2',
      autoFocus: false,
    });

    this.subscription.add(
      shareTypeDialog.afterClosed().subscribe((results) => {
        if (results) {
          // this.shareDetails = results;
          this.buildShareTypeText(shareDetails);

          //call update to parent component
          this.updateExistingUser(results, user);
          this.cd.markForCheck();
        }
      })
    );

    return false;
  }

  updateExistingUser(value, existingUser) {
    this.subscription.add(
      this.vaultShareService
        .updateVaultShareInformation({
          id: existingUser.vault_user_share_id,
          is_sealed: value.is_sealed,
          share_date: value.share_date,
          end_date: value.end_date,
          user_id: this.stateObject?.user_id,
          is_editable: value.is_editable,
        })
        .subscribe(async (results) => {
          //add toastr message once update is done.
          this.toastr.success(`${existingUser.user_first_name}'s access updated for ${this.stateObject.name}`);
          await this.getVaultSharingData();
          //refresh modal
          this.trackEventsInMixPanel('edit');
          this.cd.markForCheck();
        })
    );
  }

  checkAccessibility(date): string {
    const formatedDate = moment();
    if (date) {
      const diffInDays = moment(date).diff(formatedDate, 'hours');

      if (diffInDays <= 0) {
        return 'now';
      }

      if (diffInDays > 0) {
        return 'sealed';
      }
    } else {
      return 'later';
    }
  }

  checkAccessibilityTag(date): string {
    const formatedDate = moment();
    if (date) {
      const diffInDays = moment(date).diff(formatedDate, 'hours');

      if (diffInDays <= 0) {
        return 'Now';
      }

      if (diffInDays > 0) {
        return '';
      }
    } else {
      return 'Later';
    }
  }

  trackEventsInMixPanel(actionType) {
    const events =
      this.selectedVaultType === 'personal_vault'
        ? [{ eventName: EVENTS[`personal_vault_setup_${actionType}_sharing_change`] }]
        : this.selectedVaultType === 'shared_vaults'
        ? [{ eventName: EVENTS[`shared_vault_setup_${actionType}_sharing_change`] }]
        : this.selectedVaultType === 'entity_vault'
        ? [{ eventName: EVENTS[`entity_vault_setup_${actionType}_sharing_change`] }]
        : [];
    this._userService.trackEventsInMixPanel(events).then((response) => {});
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
